import { motion } from "framer-motion";
import { Reveal, MaskLine } from "./Reveal";
import { WAVELENGTHS } from "./data";

const Wave = ({ w, i }) => (
  <Reveal delay={i * 0.12} className="h-full">
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 200, damping: 20 }}
      className="group relative h-full overflow-hidden rounded-[1.75rem] bg-[#C9D6C6] border border-[#1B3B28]/10 p-8 flex flex-col"
      data-testid={`wavelength-card-${w.nm}`}
    >
      <motion.span
        className="absolute -top-16 -right-16 w-48 h-48 rounded-full blur-3xl"
        style={{ background: w.glow }}
        animate={{ opacity: [0.35, 0.6, 0.35], scale: [1, 1.12, 1] }}
        transition={{ duration: 5 + i, repeat: Infinity, ease: "easeInOut" }}
      />
      <div className="relative flex items-center justify-between">
        <span className="eyebrow text-[#1B3B28]/70">{w.light}</span>
        <span className="w-2.5 h-2.5 rounded-full shadow-[0_0_14px_3px] " style={{ background: w.glow, color: w.glow }} />
      </div>
      <p className="relative f-serif text-7xl sm:text-8xl text-[#1B3B28] leading-none mt-8">
        {w.nm}<span className="f-mono text-base tracking-[0.2em] ml-2 text-[#3E6B48]">nm</span>
      </p>
      <div className="relative h-px bg-[#1B3B28]/15 mt-6 overflow-hidden">
        <motion.span className="absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-[#1B3B28]/60 to-transparent"
          animate={{ x: ["-100%", "300%"] }} transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut", delay: i * 0.6 }} />
      </div>
      <h4 className="relative f-serif text-2xl sm:text-3xl text-[#1B3B28] mt-6 leading-tight">{w.title}</h4>
      <p className="relative text-sm text-[#1E2922]/75 mt-3 leading-relaxed">{w.text}</p>
    </motion.div>
  </Reveal>
);

export const Wavelengths = () => (
  <div className="mt-24" data-testid="wavelengths-section">
    <div className="grid lg:grid-cols-12 gap-6 items-end">
      <h3 className="lg:col-span-7 f-serif text-4xl sm:text-5xl text-[#1B3B28] leading-[1]">
        <MaskLine inView>Tre lunghezze d'onda,</MaskLine>
        <MaskLine inView delay={0.1}><em className="text-[#3E6B48]">un solo obiettivo.</em></MaskLine>
      </h3>
      <Reveal className="lg:col-span-4 lg:col-start-9" delay={0.15}>
        <p className="text-[#526356] leading-relaxed">Ogni luce viene assorbita dai tessuti in modo diverso. Combinandole, il trattamento diventa più mirato, più delicato e più efficace.</p>
      </Reveal>
    </div>
    <div className="mt-12 grid gap-5 md:grid-cols-3">
      {WAVELENGTHS.map((w, i) => <Wave key={w.nm} w={w} i={i} />)}
    </div>
  </div>
);
